import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Styles from './index.module.scss';

const Exception = ({ className, image, tips }) => (
  <div className={cx(Styles.root, className)}>
    <div className={Styles.image} style={{ backgroundImage: `url(${image})` }} src={image} alt="exception" />
    <div className={Styles.tips}>{tips}</div>
  </div>
);

Exception.propTypes = {
  className: PropTypes.string,
  image: PropTypes.string,
  tips: PropTypes.string,
};

Exception.defaultProps = {
  className: '',
  image: '',
  tips: '',
};

export default Exception;
